module.exports = __webpack_public_path__ + "static/media/Flowers.97f28310.jpg";